<template>
  <div class="item__quantity">
    <span class="item__quantity-control" @click="changeQuantity('minus')">
      -
    </span>
    <span> {{ quantity }} </span>
    <span class="item__quantity-control" @click="changeQuantity('plus')">
      +
    </span>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    quantity: number
  }>(),
  {
    quantity: 1,
  }
)
const emit = defineEmits<{
  (e: 'update', type: string): void
}>()
function changeQuantity(type: string) {
  emit('update', type)
}
</script>

<style lang="scss">
.item__quantity {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  border-radius: var(--border-radius-medium);
  border: solid 1px var(--border-color-box);
  height: var(--product-option-choice-height);
  background-color: var(--lavender);
  transition: all .2s;
  &:hover {
    background-color: var(--accent-secondary-hover);
    background-color: color-mix(in srgb, var(--accent-secondary-hover) 50%, var(--lavender));
  }

  span {
    width: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    height: 100%;
  }

  &-control {
    font-size: 18px;
    cursor: pointer;
    font-weight: normal;
  }
}
</style>
